<template>
    <div class="bar">
        <img class="img-fluid" :src="image" alt="Progress image 1">
        <div class="text-header">
            <span>TU <span class="text-gold">TARJETA</span></span><br>
            <span class="black-bg">GARLAN'S</span>
        </div>
        <img v-if="image2" :src="image2" class="img-cards" alt="Progress image 1">
        <div class="bar-container">
            <progress-bar bar-color="#F7D85C" :val="percentage" :text="percentage+'%'" :style="cssVars"></progress-bar>
        </div>
        
    </div>
</template>

<script>
import ProgressBar from 'vue-simple-progress'
    export default {
        components: {
            ProgressBar
        },
        props: {
            percentage: {
                type: Number,
                required: true
            },
            image: {
                type: String,
                required: true
            },
            image2: {
                type: String,
                required: false
            }
        },
        computed: {
            cssVars () {
                return{
                /* variables you want to pass to css */
                '--left': this.percentage-2+'%',
                }
            }
        }
    }
</script>

<style scope>
.bar{
    position: relative;
}

.text-header{
    font-family: futura-pt, sans-serif;
    font-weight: 600;
    font-style: normal;
    position: absolute;
    top: 5%;
    color: #fff;
    text-align: center;
    font-size: 35px;
    line-height: 1.2;
    left: 28%;
}
.text-gold{
    color:#F7D85C;
}
.black-bg{
    background: #000;
    padding: 0 5px;
}

.bar-container .vue-simple-progress-text{
  position: absolute;
  top: -30px; 
  font-family: 'Poppins', sans-serif;
  font-weight: bold;
  color: #F7D85C !important;
  left: var(--left) !important;
}
.img-cards{
    position: absolute;
    width: 155%;
    left: -30%;
    bottom: 5%;
}
</style>